export const environment = {
  production: false,
  staging: true,
  apiUrl: 'https://website-egl1.vercel.app/api',
  logLevel: 'warn',
  enableDevTools: false,
  enableHeroVideo: true,
};
